module.exports = __webpack_public_path__ + "img/icn-plus.a529f04e.svg";